import React from 'react';

class TimeSelectionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTime: '12:00'
    };
  }

  handleTimeChange = (e) => {
    this.setState({ selectedTime: e.target.value });
  }

  handleConfirm = () => {
    this.props.onConfirm(this.state.selectedTime);
    this.props.onClose();
  }

  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <div className="modal" style={{ display: 'block' }}>
        <div className="modal-content">
          <span className="close" onClick={this.props.onClose}>&times;</span>
          <div className="modal-body">
            <h2>Выберите время</h2>
            <select value={this.state.selectedTime} onChange={this.handleTimeChange}>
              <option value="12:00">12:00</option>
              <option value="13:00">13:00</option>
              <option value="14:00">14:00</option>
              <option value="15:00">15:00</option>
            </select>
          </div>
          <div className="modal-footer">
            <button id="confirmButton" onClick={this.handleConfirm}>Подтвердить</button>
          </div>
        </div>
        <style>
          {`
            .modal {
              display: none;
              position: fixed;
              z-index: 1000;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              overflow: auto;
              background-color: rgba(0, 0, 0, 0.4);
              padding-top: 60px;
            }
            .modal-body {
              text-align: center;
            }
            .modal-footer {
              text-align: center;
              margin-top: 20px;
            }
            .modal-content {
              background-color: #fefefe;
              margin: 5% auto;
              padding: 20px;
              border: 1px solid #888;
              width: 80%;
              max-width: 450px;
            }
            .close {
              color: #aaa;
              position: absolute;
              top: 10px;
              right: 20px;
              font-size: 28px;
              font-weight: bold;
              cursor: pointer;
            }
            .close:hover,
            .close:focus {
              color: black;
              text-decoration: none;
              cursor: pointer;
            }
            select {
              display: block;
              margin: 0 auto;
              padding: 10px;
              font-size: 16px;
              height: 40px;
            }
            #confirmButton {
              background-color: #6d70d7;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 16px;
              margin-top: 20px;
            }
            #confirmButton:hover {
              background-color: #5c5f9e;
            }
          `}
        </style>
      </div>
    );
  }
}

export default TimeSelectionModal;
